import { render, staticRenderFns } from "./LawMatterCustomsRegistrationListOfLast1MonthExpirationDateReportList.vue?vue&type=template&id=6cd9604d&"
import script from "./LawMatterCustomsRegistrationListOfLast1MonthExpirationDateReportList.vue?vue&type=script&lang=js&"
export * from "./LawMatterCustomsRegistrationListOfLast1MonthExpirationDateReportList.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterCustomsRegistrationListOfLast1MonthExpirationDateReportList.vue?vue&type=style&index=0&id=6cd9604d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports